import React from 'react';

// Components
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './GoalDetailPanelLoading.scss';

const GoalDetailPanelLoading = () => {
  const baseClassName = 'GoalDetailPanelLoading';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__body`}>
        <div className={`${baseClassName}__body__content`}>
          <LoadingShimmer shape="rectangle" width="80%" height="24px" />
          <LoadingShimmer shape="rectangle" width="80%" height="24px" />
        </div>
      </div>
      <div className={`${baseClassName}__details`}>
        <div className={`${baseClassName}__details__item`}>
          <LoadingShimmer shape="rectangle" width="100px" height="24px" />
          <LoadingShimmer shape="rectangle" width="175px" height="24px" />
        </div>
        <div className={`${baseClassName}__details__item`}>
          <LoadingShimmer shape="rectangle" width="100px" height="24px" />
          <LoadingShimmer shape="rectangle" width="175px" height="24px" />
        </div>
        <div className={`${baseClassName}__details__item`}>
          <LoadingShimmer shape="rectangle" width="100px" height="24px" />
          <LoadingShimmer shape="rectangle" width="175px" height="24px" />
        </div>
      </div>
    </div>
  );
};

export default GoalDetailPanelLoading;
